<template>
	<div>
		<Top :showmoreclass="showmoreclass" flag="1"></Top>
		<div class="home">
			<div v-for="(item, index) in wddatalist" :key="index">
				<div v-if="item.type == 2">
					<!-- 轮播图 -->
					<el-carousel :interval="5000" arrow="always">
						<el-carousel-item v-for="(itemp, indexp) in item.wdpicslist" :key="indexp">
							<el-image :src="itemp.picurl" fit="fill" @click="goto(itemp.url)"  :class="itemp.link1!=''?'wd-cursor':''" class="carousel wd-img-percent-100"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-else-if="item.type == 6">
					<!--辅助空白-->
					<div class="wdline5 "></div>
				</div>
				<div v-else-if="item.type == 7">
					<!--分隔线-->
					<div class="wdline1"></div>
				</div>
				<div v-else-if="item.type == 8" class="wd-container"><!--商品列表-->
					<div class="goodslist5" :style="{background:item.fontbackgroundcolor}">
						<template v-for="(item2, index2) in item.wdgoodslist">
							<div class="goods" :key="index2" @click="gotogoodsdetail(item2.goodsid, item2.goodsname)">
								<div class="img"><el-image :src="$wdpicurl(item2.pic1)" fit="contain" class="img"></el-image></div>
								<div class="name">{{ item2.goodsname }}</div>
								<div class="price">
									<span>¥{{ item2.appprice |amountFormatter }}</span>
									<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold" v-if="item2.appprice!=item2.plusprice">¥{{item2.plusprice|amountFormatter}}</span>
									<span class="pluscss"  v-if="item2.appprice!=item2.plusprice">PLUS</span>
									<span class="wd-theme-999 wd-font-delete wd-font-12 wd-m-l-10" v-if="item2.appprice==item2.plusprice">¥{{ item2.retailprice|amountFormatter }}</span>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div v-else-if="item.type == 9" class="wd-container">
					<!--图片-->
					<el-row class="" v-if="item.param<5">
						<el-col v-if="item.pic1!=''" :span="getspan(item.param)"><el-image @click="goto(item.link1)" class="wd-width-percent-100" :class="item.link1!=''?'wd-cursor':''" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic2!=''" :span="getspan(item.param)"><el-image @click="goto(item.link2)" class="wd-width-percent-100" :class="item.link2!=''?'wd-cursor':''" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic3!=''" :span="getspan(item.param)"><el-image @click="goto(item.link3)" class="wd-width-percent-100" :class="item.link3!=''?'wd-cursor':''" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic4!=''" :span="getspan(item.param)"><el-image @click="goto(item.link4)" class="wd-width-percent-100" :class="item.link4!=''?'wd-cursor':''" :src="$wdpicurl(item.pic4)" fit="fill" :lazy="true"></el-image></el-col>
					</el-row>
					<el-row v-else-if="item.param==5">
						<el-col :span="12">
							<div>
								<el-image @click="goto(item.link1)" :class="item.link1!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image>		
							</div>
							<div>
								<el-image @click="goto(item.link2)" :class="item.link2!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image>
							</div>
						</el-col>
						<el-col :span="12">
							<el-image @click="goto(item.link3)" :class="item.link3!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image>
						</el-col>
					</el-row>
					<el-row v-else-if="item.param==6">
						<el-col :span="12">
							<el-image @click="goto(item.link1)" :class="item.link1!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image>
						</el-col>
						<el-col :span="12">
							<div>
								<el-image @click="goto(item.link2)" :class="item.link2!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image>		
							</div>
							<div>
								<el-image @click="goto(item.link3)" :class="item.link3!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image>
							</div>
						</el-col>
					</el-row>
				</div>
				<div v-else-if="item.type == 11" class="wd-container"><!--搜索--></div>
				<div v-else-if="item.type == 12" class="wd-container"><!--文字-->
					<div 
					:style="{color:item.fontcolor,fontSize:item.fontsize+'px',textAlign:item.fontalign,fontWeight:item.fontweight,padding:item.fontpadding+'px',margin:item.fontmargin+'px',backgroundColor:item.fontbackgroundcolor}">
					{{item.memo}}
					</div>
				</div>
				<div v-else-if="item.type == 13" class="wd-container"><!--爆品--></div>
				<div v-else-if="item.type == 14" class="wd-container "><!--每日必抢-->
					<div class="wd-flex seckillcss">
						<div class="countdown" v-if="startcountdown_s">
							<div class="title">每日必抢</div>
							<div class="value">开始倒计时</div>
							<div class="timer">
								<div class="a">{{sechour}}</div>
								<div class="a">{{secminute}}</div>
								<div class="a b">{{secsecond}}</div>
							</div>
						</div>
						<div class="countdown wd-cursor" v-else @click="gotoseckill">
							<div class="title">每日必抢</div>
							<div class="value">结束倒计时</div>
							<div class="timer">
								<div class="a">{{sechour}}</div>
								<div class="a">{{secminute}}</div>
								<div class="a b">{{secsecond}}</div>
							</div>
						</div>
						<div v-for="(goodsitem,goodsindex) in seckilldatalist" :key="goodsindex" class="goodsinfo wd-flex-col wd-cursor" @click="gotogoodsdetail(goodsitem.goodsid)">
							<div class="img">
								<el-image :src="$wdpicurl(goodsitem.pic1)"></el-image>
							</div>
							<div class="name wd-line-2">
								{{goodsitem.goodsname}}
							</div>
							<div class="wd-flex price">
								<div class="a">
									<span class="wd-font-12">¥</span>{{goodsitem.price1|amountFormatter}}
								</div>
								<div class="b">
									¥{{goodsitem.retailprice|amountFormatter}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="classlist wd-container" ref="classlist"  v-else-if="item.type == 16"><!-- 商品分类 -->
					<div v-for="(item, index) in allclasslist" :key="index" class="floorright">
						<div class="wd-flex wd-row-between">
							<div class="title">{{ item.name }}</div>
							<div class="wd-flex wd-row-between wd-row-grow">
								<div><span class="wd-info">全部</span></div>
								<div class="wd-info">
									<router-link :to="{path:'/goodslist',query:{contype:3,classid:item.id,showname:item.name}}" tag="div">
										<span>更多</span>
										<i class="wd-m-l-5 wd-icon wd-font-12">&#xe606;</i>
									</router-link>
									
								</div>
							</div>
						</div>
						<div class="detail wd-flex wd-row-between">
							<div class="brand">
								<div class="n1"><el-image :src="$wdpicurl(item.adweb1)" class="img"></el-image></div>
								<div class="n2"><el-image :src="$wdpicurl(item.adweb2)" class="img"></el-image></div>
							</div>
							<div class="goodslist">
								<template v-for="(item2, index2) in item.detail">
									<div class="goods" :key="index2" @click="gotogoodsdetail(item2.goodsid, item2.goodsname)">
										<div class="img"><el-image :src="$wdpicurl(item2.pic1)" fit="contain" class="img"></el-image></div>
										<div class="name">{{ item2.goodsname }}</div>
										<div class="price">
											<span>¥{{ item2.appprice|amountFormatter }}</span>
											<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold" v-if="item2.appprice!=item2.plusprice">¥{{item2.plusprice|amountFormatter}}</span>
											<span class="pluscss"  v-if="item2.appprice!=item2.plusprice">PLUS</span>
											<span class="wd-theme-999 wd-font-delete wd-font-12 wd-m-l-10" v-if="item2.appprice==item2.plusprice">¥{{ item2.retailprice|amountFormatter }}</span>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- 导航楼层 -->
					<div class="daohang" :class="[showdaohang ? 'show' : '']">
						<div v-for="(item, index) in allclasslist" :key="index" class="row navleft" @click="setFloorNavMountClick(index)">
							<span>{{ index + 1 }}F</span>
							<span>{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Index',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			code: 'webindex',
			wddatalist: [],
			wdpicslist: [],
			allclasslist: [],
			allclass_goods_list: [],
			allclasstop: 1200,
			showdaohang: false,
			seckilldatalist: [],
			seckillinfo: { id: 0 },
			allseconds: 0,
			allseconds_start:0,
			showmoreclass:false,
			sechour:0,
			secminute:0,
			secsecond:0,
			sechour_s:0,
			secminute_s:0,
			secsecond_s:0,
			seckilltimer:null,
			startcountdown_s:false,
		};
	},
	methods: {
		getspan(param) {
			switch (param) {
				case '1':
					return 24;
				case '2':
					return 12;
				case '3':
					return 8;
				case '4':
					return 6;
				default:
					return 24;
			}
		},
		init() {
			document.title = this.$wd_title;
			this.getdiv();
			this.getindexclass();
			this.loadallclass();
			this.loadseckillinfo();
			this.loadsuggestlist();
		},
		diffTime(min) {
			var diff=min*1000;//endDate.getTime() - startDate.getTime();//时间差的毫秒数  
			// if (isstart){
			// 	this.allseconds_start=diff;
			// 	if (diff<=0){
			// 		this.sechour_s=0;
			// 		this.secminute_s=0;
			// 		this.secsecond_s=0;
			// 		return;
			// 	}
			// }else{
			// 	this.allseconds=diff;
			// 	if (diff<=0){
			// 		this.sechour=0;
			// 		this.secminute=0;
			// 		this.secsecond=0;
			// 		return;
			// 	}	
			// }
			//计算出相差天数  
			// var days=Math.floor(diff/(24*3600*1000));  
			//计算出小时数  
			var leave1=diff%(24*3600*1000);    //计算天数后剩余的毫秒数  
			var hours=Math.floor(leave1/(3600*1000));  
			//计算相差分钟数  
			var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
			var minutes=Math.floor(leave2/(60*1000));  
			//计算相差秒数  
			var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
			var seconds=Math.round(leave3/1000);  
			
			hours = hours < 10 ? '0' + hours : hours;
			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;
			
			// if (isstart){
			// 	this.sechour_s=hours;
			// 	this.secminute_s=minutes;
			// 	this.secsecond_s=seconds;
			// 	this.startcountdown_s=true;
			// }else{
				this.sechour=hours;
				this.secminute=minutes;
				this.secsecond=seconds;
				this.startcountdown=true;
			// }
		}, 
		loadseckillinfo() {
			var indata = {
				limit: 1,
				type: 0
			};

			this.$wd_request('seckilllist', indata)
				.then(data => {
					this.seckillinfo = data.value[0];
					if (this.seckillinfo.intdiffs < 0) {
						// this.diffTime(this.seckillinfo.intdiffs*-1,true);
						// this.diffTime(this.seckillinfo.intdiff);
						this.startcountdown_s = true;
						setTimeout(function() {
							this.allseconds_start = 0;
							this.allseconds=this.seckillinfo.intdiff;
							this.startcountdown_s = false;
							this.start_calcseckill(this.seckillinfo.intdiff);
							// that.diffTime(that.seckillinfo.intdiff+that.seckillinfo.intdiffs);
						}, this.seckillinfo.intdiffs * -1000);
					} else {
						this.startcountdown_s = false;
						this.startcountdown = true;
						this.allseconds=this.seckillinfo.intdiff;
						// this.diffTime(this.seckillinfo.intdiff);
						this.start_calcseckill();
					}
					this.loadseckillgoodslist();
				})
				.catch(() => {});
		},
		loadseckillgoodslist() {
			var indata = {
				limit: 5,
				seckillid: this.seckillinfo.id
			};

			this.$wd_request('seckill_goodslist', indata)
				.then(data => {
					this.seckilldatalist = data.value;
				})
				.catch(() => {});
		},
		start_calcseckill(){
			this.clear_calcseckill();
			this.seckilltimer = setInterval(() => {
				this.allseconds--;
				if (this.allseconds < 0) {
					return this.clear_calcseckill();
				}
				this.diffTime(this.allseconds,this.startcountdown_s);
				
			}, 1000);
		},
		clear_calcseckill(){
			clearInterval(this.seckilltimer);
			this.seckilltimer = null;
		},
		gotoseckill() {
			this.$router.push({name:"Miaosha"});
		},
		loadsuggestlist() {
			var indata = {
				contype: 5,
				limit: 2
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					this.suggestdatalist = data.value;
				})
				.catch(() => {});
		},
		loadtradetypelist() {
			var indata = {
				contype: 5,
				limit: 2,
				con: '海外直邮'
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					this.tradetypedatalist = data.value;
				})
				.catch(() => {});
		},
		goto(module){
			console.log(module);
			let code = module.substr(0, 4);
			if (module == "main") {
				this.$router.push("/");
			} else if (module == "my") {
				this.$router.push("/member");
			} else if (module == "search") {
				this.$router.push("/goodslist");
			} else if (module == "cart") {
				this.$router.push("/cart");
			} else if (code == "code") {
				this.$router.push({path:"/Diy",query:{code:code}});
			} else if (code == "con=") {
				this.$router.push({path:"/goodslist"});
			} else if (code == "good") {
				this.$router.push({path:"/goodsinfo",query:{goodsid:module.substr(8,module.length-8)}});
			} else if (module == "pintuan") {
				this.$router.push("/pintuan");
			} else if (module == "yushou") {
				this.$router.push("/yushou");
			} else {
				this.$router.push(module);
			}
		},
		getdiv() {
			let indata = {
				code: this.code
			};
			this.$wd_request('getdiy', indata)
				.then(data => {
					this.wddatalist = data.value;
					this.getgoodslist();
					this.getpiclist();
				})
				.catch(() => {});
		},
		getindexclass() {
			let indata = {
				type: 'class'
			};
			this.$wd_request('getindex', indata)
				.then(data => {
					this.wdclasslist = data.value;
				})
				.catch(() => {});
		},
		getindexpics(index) {
			var item = this.wddatalist[index];
			let indata = {
				type: item.pictype,
			};

			this.$wd_request('getindex', indata)
				.then(data => {
					item.wdpicslist = data.value;
					this.$set(this.wddatalist, index, item);
				})
				.catch(() => {});
		},
		getpiclist() {
			for (var i = 0; i < this.wddatalist.length; i++) {
				let ii = i;
				let item = this.wddatalist[i];
				if (item.type == '2') {
					this.getindexpics(ii);
				}
			}
		},
		getgoods(item) {
			let indata = {
				con: '',
				classid: 0,
				contype: 9,
				detailid: item.id,
				branchid: this.branchid
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					item.wdgoodslist = data.value;
				})
				.catch(() => {});
		},
		getgoodslist() {
			for (var i = 0; i < this.wddatalist.length; i++) {
				var item = this.wddatalist[i];
				if (item.type == '8') {
					this.getgoods(item);
				}
			}
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				path: '/goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		loadallclass() {
			this.$wd_request('appgoodsclass_main')
				.then(data => {
					if (data.rs == 0) {
						this.allclasslist = data.value;
						for (var i = 0; i < this.allclasslist.length; i++) {
							this.findallclassgoods(i, this.allclasslist[i].id);
						}
					}
				})
				.catch(() => {});
		},
		findallclassgoods(index, classid) {
			let indata = {
				cnt: -1,
				page: 1,
				contype: 8,
				con: '',
				classid: classid,
				limit: 8
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					var item = this.allclasslist[index];
					item.detail = data.value;
					this.$set(this.allclasslist, index, item);
				})
				.catch(() => {});
		},
		loadcarousellist() {
			this.$wd_request('getindex', { type: 'webindex' }).then(data => {
				this.carousellist = data.value;
			});
		},
		/**
		 * 监听窗口滚动楼层导航动态定位
		 */
		floorSrcollEventListener() {
			// var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// if (scrollTop > this.allclasstop) {
			// 	this.showdaohang = true;
			// } else {
			// 	this.showdaohang = false;
			// }
			this.showdaohang = false;
			const { nav_item, floor_item } = this.element;
			const window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			for (let i = 0, len = floor_item.length; i < len; i++) {
				let floor_offsetTop = floor_item[i].offsetTop-600 ;//- floor_item[0].offsetTop;
				if (window_scrollTop >= floor_offsetTop) {
					this.showdaohang = true;
					for (let n = 0, len = nav_item.length; n < len; n++) {
						const current_classList = nav_item[n].classList;
						i === n ? current_classList.add('active') : current_classList.remove('active');
					}
				}
			}
		},
		/**
		 * 设置楼层导航事件驱动方法
		 * @param {Number} index  楼层下标
		 */
		setFloorNavMountClick(index) {
			const { floor_item } = this.element;
			const floor_offsetTop = floor_item[index].offsetTop-300,// - floor_item[0].offsetTop,
				window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
				timer = {
					step: 300,
					times: 16,
					FLOOR_OFFSETTOP: floor_offsetTop
				};
			if (window_scrollTop > floor_offsetTop) {
				this.setFloorScrollArrowUp(timer);
			} else if (window_scrollTop == floor_offsetTop) {
				return false;
			} else {
				this.setFloorScrollArrowDown(timer);
			}
		},
		/**
		 * 设置楼层向上滚动
		 * @param {Object} timer 定时器配置
		 */
		setFloorScrollArrowUp(timer) {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (window_scrollTop <= timer.FLOOR_OFFSETTOP) {
					document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP;
					document.body.scrollTop = timer.FLOOR_OFFSETTOP;
					clearInterval(this.timer);
				} else {
					document.documentElement.scrollTop = window_scrollTop - timer.step;
					document.body.scrollTop = window_scrollTop - timer.step;
				}
			}, timer.times);
		},
		/**
		 * 设置楼层向下滚动
		 * @param {Object} timer 定时器配置
		 */
		setFloorScrollArrowDown(timer) {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (window_scrollTop >= timer.FLOOR_OFFSETTOP) {
					document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP;
					document.body.scrollTop = timer.FLOOR_OFFSETTOP;
					clearInterval(this.timer);
				} else {
					document.documentElement.scrollTop = window_scrollTop + timer.step;
					document.body.scrollTop = window_scrollTop - timer.step;
				}
			}, timer.times);
		}
	},
	created() {
		this.code="webindex";
		this.init();
		if (this.code==="webindex"){
			this.showmoreclass=true;
		}
	},
	// activated() {
	// 	console.log("active");
	// 	let aflag=this.$route.params.code||"";
	// 	if (aflag==""){
	// 		aflag=this.$route.query.code||"";
	// 	}
	// 	if (aflag!=="" && aflag!==this.code){
	// 		this.code=aflag;
	// 		this.init();
	// 	}
	// },
	mounted() {
		this.$nextTick(function(){
			this.element = {
				nav_item: document.getElementsByClassName('navleft'),
				floor_item: document.getElementsByClassName('floorright')
			};
			window.addEventListener('scroll', this.floorSrcollEventListener,true);
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.floorSrcollEventListener,true);
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
	white-space: nowrap;
}
.seckillcss{
	height: 260px;
	width: 100%;
	margin-bottom: 20px;
	.countdown{
		width: 190px;
		height: 100%;
		color: #FFFFFF;
		background-color: #e83632;
		background-size: contain;
		background-position: 50%;
		background-repeat: no-repeat;
		background-image: url("../assets/miaosha.png");
		flex-shrink: 0;
		.title{
			width: 100%;
			text-align: center;
			font-size: 30px;
			font-weight: 700;
			margin-top: 30px;
		}
		.value{
			margin-top: 100px;
			text-align: center;
		}
		.timer{
			margin-top: 20px;
			font-size: 14px;
			text-align: center;
			margin-left: auto;
			margin-right: auto;
			width: 130px;
			height: 30px;
			display: block;
			.a{
				position: relative;
				float: left;
				width: 30px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background-color: #2f3430;
				margin-right: 20px;
				color: white;
				font-size: 20px;
				&::after{
					content: ":";
					display: block;
					position: absolute;
					right: -20px;
					font-weight: bolder;
					font-size: 18px;
					width: 20px;
					height: 100%;
					top: 0;
				}
				&.b{
					margin-right: 0;
					&::after{
						content: "";
					}
				}
			}
		}
	}
	.goodsinfo{
		padding: 0 10px;
		height: 260px;
		width: 202px;
		.img{
			width: 140px;
			height: 140px;
			margin-top: 30px;
			margin-left: auto;
			margin-right: auto;
			.el-image{
				width: 100%;
				height: 100%;
			}
		}
		.name{
			margin: 10px 0;
			width: 180px;
			height: 44px;
			line-height: 22px;
			&:hover{
				color:#e1251b;
			}
		}
		.price{
			
			border: 1px solid #e1251b;
			position: relative;
			box-sizing: border-box;
			line-height: 24px;
			overflow: hidden;
			background-color: #e1251b;
			width: 180px;
			margin: auto;
			.a{
				width: 102px;
				height: 100%;
				text-align: center;
				color:#fff;
				font-size: 16px;
				font-weight: 700;
				line-height: 22px;
				&::before{
					content: " ";
					width: 0;
					height: 0;
					border-color: transparent white transparent transparent;
					border-style: solid;
					border-width: 22px 8px 0 0;
					position: absolute;
					top: 0;
					left: 94px;
				}
			}
			.b{
				width: 76px;
				height: 100%;
				background-color: #fff;
				text-align: center;
				color: #999;
				font-size: 12px;
				line-height: 22px;
				box-sizing: border-box;
				text-decoration: line-through;
				vertical-align: top;
			}
		}
	}
}
.home {
	.calousel {
		width: 100%;
		height: 100%;
	}
	.ad1list {
		margin-top: 30px;
		.img {
			border-radius: 5px;
			.img2 {
				background-color: #ffffff;
				border-radius: 5px;
			}
		}
	}
	.hot {
		.title {
			width: 240px;
			height: 36px;
			font-weight: 500;
			font-size: 26px;
			color: #333;
			font-weight: bold;
			border-left: 6px solid #ff4c4c;
			padding-left: 10px;
			line-height: 36px;
			margin: 30px 0 15px;
		}
		.detail {
			height: 300px;
			width: 100%;
			.goods {
				width: 300px;
				height: 300px;
				display: inline-block;
				padding: 0 10px;
				.img {
					width: 250px;
					height: 250px;
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
	.classlist {
		.title {
			width: 240px;
			height: 36px;
			font-weight: 500;
			font-size: 26px;
			color: #333;
			font-weight: bold;
			border-left: 6px solid #ff4c4c;
			padding-left: 10px;
			line-height: 36px;
			margin: 30px 0 15px;
		}
		.wd-info{
			cursor: pointer;
		}
		.brand {
			width: 240px;
			min-height: 1px;
			height: 588px;
			.n1 {
				display: block;
				width: 240px;
				height: 436px;
				overflow: hidden;
				margin-bottom: 14px;
				.img {
					display: block;
					width: 240px;
					height: 436px;
					object-fit: cover;
					border-radius: 5px;
				}
			}
			.n2 {
				display: block;
				width: 240px;
				height: 124px;
				overflow: hidden;
				.img {
					display: block;
					width: 240px;
					height: 124px;
					border-radius: 5px;
					object-fit: cover;
				}
			}
		}
		.detail {
			height: 588px;
			.goods {
				float: left;
				width: 226px;
				height: 280px;
				background-color: #fff;
				overflow: hidden;
				text-align: center;
				margin-left: 14px;
				border-radius: 5px;
				margin-bottom: 14px;
				transition: 0.5s;
				.img {
					width: 160px;
					height: 160px;
					margin: 10px auto 0;
					overflow: hidden;
				}
				.name {
					font-size: 14px;
					width: 200px;
					height: 40px;
					line-height: 20px;
					color: #666;
					margin: 20px auto 0;
					overflow: hidden;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
				.price {
					font-size: 14px;
					width: 200px;
					height: 40px;
					line-height: 40px;
					color: #ff4c4c;
					margin: 0px auto 0;
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
	.daohang {
		background-color: #ffffff;
		position: fixed;
		top: 30%;
		margin-left: -100px;
		z-index: 20;
		border: 1px solid #ddd;
		display: none;
		&.show {
			display: block;
		}
		.row {
			width: 50px;
			height: 30px;
			padding: 5px;
			line-height: 15px;
			font-size: 12px;
			color: #999;
			text-align: center;
			overflow: hidden;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			&:nth-last-child(1) {
				border-bottom: 0;
			}
			&.active {
				color: #ffffff;
				background-color: #aaa;
			}
			span {
				display: block;
				height: 15px;
				width: 50px;
				overflow: hidden;
			}
		}
	}
}
::v-deep .el-carousel__container {
	height: 480px !important;
}
.goodslist5{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		.goods {
			width: 226px;
			height: 280px;
			background-color: #fff;
			overflow: hidden;
			text-align: center;
			margin-left: 14px;
			border-radius: 5px;
			margin-bottom: 14px;
			transition: 0.5s;
			.img {
				width: 160px;
				height: 160px;
				margin: 10px auto 0;
				overflow: hidden;
			}
			.name {
				font-size: 14px;
				width: 200px;
				height: 40px;
				line-height: 20px;
				color: #666;
				margin: 20px auto 0;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
			}
			.price {
				font-size: 14px;
				width: 200px;
				height: 40px;
				line-height: 40px;
				color: #ff4c4c;
				margin: 0px auto 0;
			}
			&:hover {
				cursor: pointer;
				box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
				//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
			}
		}
	}
</style>
